import DeviceManager from "../utils/device-manager";
import $ from "jquery";
import Flickity from "flickity-fade";
require("flickity-imagesloaded");

class FavoritesProduct {
  constructor($el) {
    this.$el = $el;

    this.options = {
      autoPlay: true,
      pageDots: true,
      wrapAround: true,
      prevNextButtons: true,
      imagesLoaded: true,
      cellSelector: ".product",
      cellAlign: "left",
    };

    if (this.$el.length) {
      this._init();
      this._bindEvents();
    }
  }

  _init() {
    this.$slides = this.$el.find(".product");
    this.slidesCount = this.$slides.length;

    if (this.slidesCount > 3 && document.body.clientWidth < 1200) {
      this._createSlider();
      console.log("slider mobile");
    } else if (this.slidesCount > 4 && document.body.clientWidth > 1200) {
      this._createSlider();
      console.log("slider desktop");
    } else {
      console.log("no slider");
    }
  }

  _bindEvents() {
    this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

    DeviceManager.on(
      "device-manager:breakpointChange",
      this._onBreakpointChangeFn
    );
  }

  _destroy() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }

  _onBreakpointChange() {
    if (document.body.clientWidth <= 845 && this.slidesCount > 1) {
      this._destroy();
      this._createSlider();
      console.log("slider resize mobile");
    } else if (
      document.body.clientWidth > 845 &&
      document.body.clientWidth < 1200 &&
      this.slidesCount > 3
    ) {
      this._destroy();
      this._createSlider();
      console.log("slider resize tablette");
    } else if (document.body.clientWidth > 1200 && this.slidesCount > 4) {
      this._destroy();
      this._createSlider();
      console.log("slider desktop x4");
    } else {
      this._destroy();
    }
  }

  _createSlider() {
    this.slider = new Flickity(this.$el[0], this.options);
  }
}

export default FavoritesProduct;
